// Styles
import '@/assets/styles/main.css'

// Vue dependencies
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { RegleVuePlugin } from '@regle/core'

// App
import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'
// import { useCatalogsStore } from '@/stores/catalogs.store'

// Analytics and error tracking
import posthog from 'posthog-js'
import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'

const app = createApp(App)

const pinia = createPinia()
pinia.use(createSentryPiniaPlugin())

app.use(pinia)
app.use(router)
app.use(RegleVuePlugin)

Sentry.init({
  app,
  dsn: 'https://c70f508bb0d4293d5234ff7f13f6d447@o4511259641839616.ingest.de.sentry.io/4511259847753809',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

posthog.init(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN || '', {
  api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
  capture_pageview: 'history_change',
  opt_out_capturing_by_default: true,
  defaults: '2026-01-30',
})

app.config.errorHandler = (err) => {
  posthog.captureException(err)
}

// Initialize authentication before mounting the app
const authStore = useAuthStore()
// const catalogsStore = useCatalogsStore()

authStore.initializeAuth().then(async () => {
  authStore.setupAuthListener()

  // Load catalogs if user is authenticated
  // if (authStore.isAuthenticated) {
  //   try {
  //     await catalogsStore.loadAll()
  //   } catch (error) {
  //     console.error('Failed to load catalogs:', error)
  //     // App will still mount even if catalogs fail to load
  //   }
  // }

  app.mount('#app')
})
